
export const TABLE_NAME = 'Order History';
export const TABLE_SUBTITLE = 'Click an order to view more details. Time displayed reflects when the order was placed in the restaurant\'s local timezone.';
export const STORES_PAGE_PLACEHOLDER = 'Search a Order ID';

// Columns configuration for order history
export const ORDER_HISTORY_COLUMNS = [ 
				{ key: 'merchantOrderId', label: 'Order ID', tableOrder: 1 },
				{ key: 'orderStatus', label: 'Status', tableOrder: 2 },
				{ key: 'orderDate', label: 'Date', tableOrder: 3 },
				{ key: 'time', label: 'Time', tableOrder: 4 },
				{ key: 'storeDetails', label: 'Store Details', tableOrder: 5 },
				{ key: 'orderSubTotal', label: 'Subtotal', tableOrder: 6 },
			];

export const ORDER_SUMMARY_COLUMNS = [
				{ key: 'orders', label: 'Orders' },
				{ key: 'totalOrders', label: 'Total Orders' },
				{ key: 'avgOrderValue', label: 'Average Order Value' },
				{ key: 'cancelledOrders', label: 'Cancelled Orders' },
				//{ key: 'totalPayout', label: 'Total Payout' }
			];

export const ORDER_DETAILS = 'Order Details';
export const GET_HELP = ' Get Help';
export const DELIVERED_TEXT = 'Delivered';
export const DELIVERED_DES = 'This order has been delivered to the customer.';
export const CANCELLED_TEXT = 'Cancelled';
export const CANCELLED_DESC = 'This order has been cancelled by the customer.';
export const SERVER_ERROR = 'Server Error';
export const SERVER_ERROR_DESC = 'Please try again later';
export const DELIVERY_DETAILS = 'Delivery Details';
export const PICK_UP_TIME = 'Pick Up Time';
export const DELIVERY_TIME = 'Delivery Time';
export const STORE_LOCATION = 'Store Location';
export const CUSTOMER_TEXT = 'Customer';
export const DRIVER_TEXT = 'Driver';
export const OREDER_RECIPT_TEXT = 'Order Receipt';
export const TAX_TEXT = 'Tax'
export const MARKET_TEXT = 'Marketplace Fees'
export const CUSTOMER_REFUND_TEXT = 'Customer Refund'
export const SUBTOTAL_TEXT = 'Subtotal';
export const PAYOUT_TEXT = 'Payout';
export const TRANS_TEXT='Transactions';
export const HELP_DESC_TEXT = 'Contact us via phone to get help from our support team - 24 X 7.';
export const CALL_NUM_TEXT = 'Call 855-711-7669';
export const CALL_NUM = '855-711-7669';
export const CLOSE_TEXT = 'Close';
export const DOWNLOAD_REPORT = 'Download Report';
export const DOWNLOAD_TEXT = 'Download';
export const SUB_TITLE = 'Please select the type of report to download.';
export const DOWNLOAD_DES = 'Please select the type of report to download.';
export const DOWNLOAD_OPTIONS = [{ label: 'Spreadsheet (CSV)', value: false }, { label: 'Spreadsheet (XLS/XLSX)', value: false }];
export const CHECKBOX_SELECTOR = 'CheckBox';
export const RADIO_SELECTOR = 'Radio';
export const NO_PREVIOUS_ORDER_HISTORY = 'No previous order history.';
